import { render, staticRenderFns } from "./GoRiders.vue?vue&type=template&id=58953de9&scoped=true&"
import script from "./GoRiders.vue?vue&type=script&lang=js&"
export * from "./GoRiders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58953de9",
  null
  
)

export default component.exports